module.exports = __webpack_public_path__ + "img/waring.5e9d1180.png";